(function () {
  function highlightBrandWord() {
    var re = /\btrop\b/i;
    var reGlobal = /\btrop\b/gi;
    var nodes = document.querySelectorAll('main h1, main h2, main h3, main p, main li');
    nodes.forEach(function (el) {
      if (el.dataset.brandProcessed) return;
      el.dataset.brandProcessed = '1';
      Array.from(el.childNodes).forEach(walk);
    });
    function walk(node) {
      if (node.nodeType === 3) {
        if (re.test(node.textContent)) {
          var span = document.createElement('span');
          span.innerHTML = node.textContent.replace(reGlobal, '<span class="brand-word">$&</span>');
          node.replaceWith.apply(node, Array.from(span.childNodes));
        }
      } else if (node.nodeType === 1 && node.childNodes && ['SCRIPT','STYLE','BUTTON','A'].indexOf(node.tagName) === -1) {
        Array.from(node.childNodes).forEach(walk);
      }
    }
  }

  function insertPastilles() {
    var map = [
      { match: /grandi en s.excusant/i, label: 'Sans filtre' },
      { match: /boost de confiance à enfiler/i, label: '100% toi' },
      { match: /sans surproduction/i, label: 'Sans complexe' }
    ];
    var candidates = document.querySelectorAll('main h1, main h2, main h3, main p, main strong');
    candidates.forEach(function (el) {
      if (el.dataset.pastilleDone) return;
      var text = el.textContent || '';
      for (var i = 0; i < map.length; i++) {
        if (map[i].match.test(text)) {
          var target = el.closest('h1, h2, h3, p') || el;
          if (target.dataset.pastilleDone) return;
          target.dataset.pastilleDone = '1';
          var pastille = document.createElement('span');
          pastille.className = 'brand-pastille';
          pastille.textContent = map[i].label;
          target.parentNode.insertBefore(pastille, target);
          var br = document.createElement('br');
          target.parentNode.insertBefore(br, target);
          return;
        }
      }
    });
  }

  function initCursor() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var cursor = document.createElement('div');
    cursor.id = 'brand-cursor';
    cursor.textContent = 'Voir';
    document.body.appendChild(cursor);
    document.addEventListener('mousemove', function (e) {
      cursor.style.left = e.clientX + 'px';
      cursor.style.top = e.clientY + 'px';
    });
    function bind() {
      document.querySelectorAll('.product-card, .product-media-container').forEach(function (el) {
        if (el.dataset.cursorBound) return;
        el.dataset.cursorBound = '1';
        el.addEventListener('mouseenter', function () { cursor.classList.add('is-visible'); });
        el.addEventListener('mouseleave', function () { cursor.classList.remove('is-visible'); });
      });
    }
    bind();
    setTimeout(bind, 1500);
  }

  function init() {
    insertPastilles();
    highlightBrandWord();
    initCursor();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
